module.exports = __webpack_public_path__ + "static/media/Uruli.dac4b3ae.jpg";